module.exports = __webpack_public_path__ + "f97e3bbf73254b0112091d0192f17aec.svg";